import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/saas/AuthContext";
import { useI18n, usePageTitle } from "@/i18n";
import { LanguageSelector } from "@/components/LanguageSelector";
import { saas, errMsg } from "@/lib/saasApi";

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const { t } = useI18n();
  usePageTitle("titles.changePassword");
  const nav = useNavigate();
  const forced = user?.mustChangePassword;
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) return setError(t("auth.changePassword.short"));
    if (next !== confirm) return setError(t("auth.changePassword.mismatch"));
    setLoading(true);
    try {
      await saas.changePassword(cur, next);
      await refresh();
      toast.success(t("auth.changePassword.success"));
      nav(user?.role === "OWNER_ADMIN" ? "/admin" : "/dashboard", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-re-soft px-6" data-testid="change-password-page">
      <div className="w-full max-w-md rounded-3xl border border-re-line bg-white p-8 md:p-10">
        <div className="flex justify-end"><LanguageSelector /></div>
        <h1 className="font-heading text-2xl font-bold text-re-charcoal">{t("auth.changePassword.title")}</h1>
        <p className="mt-1 text-sm text-re-muted">{t("auth.changePassword.sub")}</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-2"><Label>{t("auth.changePassword.current")}</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="cp-current" className="border-re-line" /></div>
          <div className="space-y-2"><Label>{t("auth.changePassword.next")}</Label><Input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new" className="border-re-line" /></div>
          <div className="space-y-2"><Label>{t("auth.changePassword.confirm")}</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" className="border-re-line" /></div>
          {error && <p className="text-sm text-re-red" data-testid="cp-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="cp-submit" className="w-full rounded-full bg-re-red py-6 font-semibold text-white hover:bg-re-deepred">{loading ? t("auth.changePassword.submitting") : t("auth.changePassword.submit")}</Button>
        </form>
      </div>
    </div>
  );
}
